import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhoSection() {
  return <section className="w-full px-6 py-16 md:py-20" data-id="element-102">
      <div className="max-w-2xl mx-auto" data-id="element-103">
        <AnimatedSection data-id="element-104">
          <div className="w-12 h-px bg-sand mx-auto mb-12" data-id="element-105" />
        </AnimatedSection>

        <AnimatedSection data-id="element-106">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal leading-tight mb-10" data-id="element-107">
            Para quién es<span className="text-teal" data-id="element-108">.</span>
            <br data-id="element-109" />
            <span className="text-warm-gray text-2xl md:text-3xl" data-id="element-110">
              Y para quién no.
            </span>
          </h2>
        </AnimatedSection>

        {/* For you */}
        <AnimatedSection delay={0.1} data-id="element-111">
          <div className="mb-8" data-id="element-112">
            <p className="text-teal font-semibold text-sm tracking-widest uppercase mb-5" data-id="element-113">
              Esto es para ti si:
            </p>
            <div className="space-y-4" data-id="element-114">
              <div className="flex items-start gap-3" data-id="element-115">
                <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-116">
                  <CheckIcon className="w-3.5 h-3.5 text-teal" data-id="element-117" />
                </div>
                <p className="text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-118">
                  Estás agotada y la casa ya te está afectando el ánimo.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-119">
                <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-120">
                  <CheckIcon className="w-3.5 h-3.5 text-teal" data-id="element-121" />
                </div>
                <p className="text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-122">
                  Te paraliza el "no sé por dónde empezar".
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-123">
                <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-124">
                  <CheckIcon className="w-3.5 h-3.5 text-teal" data-id="element-125" />
                </div>
                <p className="text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-126">
                  Quieres pasos concretos, cortos, sin perfeccionismo.
                </p>
              </div>
            </div>
          </div>
        </AnimatedSection>

        {/* Not for you */}
        <AnimatedSection delay={0.15} data-id="element-127">
          <div data-id="element-128">
            <p className="text-warm-gray font-semibold text-sm tracking-widest uppercase mb-5" data-id="element-129">
              Esto NO es para ti si:
            </p>
            <div className="space-y-4" data-id="element-130">
              <div className="flex items-start gap-3" data-id="element-131">
                <div className="w-6 h-6 rounded-full bg-cream-dark flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-132">
                  <XIcon className="w-3.5 h-3.5 text-warm-gray" data-id="element-133" />
                </div>
                <p className="text-warm-gray text-base md:text-lg leading-relaxed" data-id="element-134">
                  Quieres un sistema complejo de organización con compras
                  grandes.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-135">
                <div className="w-6 h-6 rounded-full bg-cream-dark flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-136">
                  <XIcon className="w-3.5 h-3.5 text-warm-gray" data-id="element-137" />
                </div>
                <p className="text-warm-gray text-base md:text-lg leading-relaxed" data-id="element-138">
                  Estás buscando minimalismo estético o remodelación.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-139">
                <div className="w-6 h-6 rounded-full bg-cream-dark flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-140">
                  <XIcon className="w-3.5 h-3.5 text-warm-gray" data-id="element-141" />
                </div>
                <p className="text-warm-gray text-base md:text-lg leading-relaxed" data-id="element-142">
                  Quieres "motivación": aquí hay protocolo, no discurso.
                </p>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}